// extracted by mini-css-extract-plugin
module.exports = {"ResultGridsContainer":"styles_ResultGridsContainer__njnOk","resultGrid":"styles_resultGrid__Kh7vY"};